import * as yup from 'yup'

import { MilestoneEditForm } from '../../../milestone/types/milestone-types'

export const MilestoneValidationSchema = (t: any) => {
  return yup.object<MilestoneEditForm>({
    name: yup.string().required(t('milestone.form.errors.name')),
    mobileApp: yup.boolean(),
    shouldBeChecked: yup.boolean(),
  })
}
